import { SEARCH_FILTER_DATA, RESET_SEARCH_FILTER_DATA } from "../actions/actionTypes"
const initialState = {
    search : null
}

const searchFilterData = (state = initialState , action) =>{
    switch(action.type){
        case SEARCH_FILTER_DATA :
            return {
                ...state,
                ...{
                    search : action.payload.search
                }
            }

            case RESET_SEARCH_FILTER_DATA :
                return {
                    ...state,
                    ...{
                        search : null
                    }


                }
            default : 
                return state;

    }
}

export default searchFilterData